export const tlPH: { [k: string]: string } = {
  

  kalusugan: 'Health',
  'kalusugan/balitang-pangkalusugan': 'Health/HealthNews',
  'kalusugan/health-insurance-fil': 'Health/Insurance',
  'kalusugan/mga-medical-tests': 'Health/DiagnosisTests',
  'kalusugan/pangkalahatang-kaalaman-sa-kalusugan': 'Health/HealthKnowledge',
  'kalusugan/medical-procedures-and-surgeries': 'Health/Surgeries',
  'kalusugan/medical-test-fil': 'Health/MedicalTest',
  'kalusugan/sintomas': 'Health/Symptoms',
  'healthy-habits-fil': 'HealthyHabits',
  'healthy-habits-fil/tumigil-paninigarilyo': 'HealthyHabits/QuitSmoking',
  'healthy-habits-fil/pangunang-lunas': 'HealthyHabits/FirstAid',
  'healthy-habits-fil/general-hygiene': 'HealthyHabits/Hygiene',
  'healthy-aging-fil': 'HealthyAging',
  'healthy-aging-fil/aktibong-pagtanda': 'HealthyAging/ActiveAging',
  'healthy-aging-fil/nutrisyon-para-sa-matatanda':
    'HealthyAging/NutritionAging',
  'healthy-aging-fil/pagtanda-katawan': 'HealthyAging/AgingBody',
  'healthy-aging-fil/mga-sakit-sa-pagtanda': 'HealthyAging/AgingConditions',
  'masustansiyang-pagkain': 'HealthyEating',
  'kalusugan-kalalakihan': 'MensHealth',
  'kalusugan-kababaihan': 'WomensHealth',
  'kalusugan-puso': 'HeartHealth',
  'diabetes-fil': 'Diabetes',
  'diabetes-fil/type-1-diabetes-fil': 'Diabetes/Type1Diabetes',
  'diabetes-fil/type-2-diabetes-fil': 'Diabetes/Type2Diabetes',
  'diabetes-fil/komplikasyon-diabetes': 'Diabetes/DiabetesComplications',

  'masustansiyang-pagkain/nutrition-facts-fil': 'HealthyEating/NutritionFacts',
  'masustansiyang-pagkain/espesyal-diyeta': 'HealthyEating/SpecialDiets',
  'masustansiyang-pagkain/diyeta-pagbaba-timbang':
    'HealthyEating/DietWeightLoss',
  'masustansiyang-pagkain/tips-masustansiyang-pagkain':
    'HealthyEating/HealthyEatingTips',
  'masustansiyang-pagkain/sports-nutrition-fil':
    'HealthyEating/SportsNutrition',
  'masustansiyang-pagkain/obesity-fil': 'HealthyEating/Obesity',
  'masustansiyang-pagkain/masustansyang-recipes':
    'HealthyEating/HealthyRecipes',
  'kalusugan-kalalakihan/kalusugan-ng-penis': 'MensHealth/PenisHealth',
  'kalusugan-kalalakihan/peyronies-disease-fil': 'MensHealth/PeyroniesDisease',
  'kalusugan-kalalakihan/mens-hormone-issues': 'MensHealth/HormoneIssues',
  'kalusugan-kalalakihan/erectile-dysfunction-fil':
    'MensHealth/ErectileDysfunction',
  'kalusugan-kalalakihan/iba-pang-isyung-pangkalusugan-ng-lalaki':
    'MensHealth/OtherMenHealthIssues',
  'kalusugan-kababaihan/regla': 'WomensHealth/Menstruation',
  'kalusugan-kababaihan/isyu-kalusugan-kababaihan':
    'WomensHealth/WomenHealthIssues',
  'kalusugan-kababaihan/uterine-fibroids-fil': 'WomensHealth/UterineFibroids',
  'kalusugan-kababaihan/pcos-fil': 'WomensHealth/Pcos',
  'kalusugan-kababaihan/vaginitis-fil': 'WomensHealth/Vaginitis',
  'kalusugan-kababaihan/menopause-fil': 'WomensHealth/Menopause',
  'kalusugan-kababaihan/screening-test-kababaihan':
    'WomensHealth/ScreeningTestsWomen',
  'kalusugan-kababaihan/problema-sa-pelvis': 'WomensHealth/PelvicIssues',
  'kalusugan-kababaihan/female-hormonal-imbalance':
    'WomensHealth/FemaleHormonalImbalance',
  'kalusugan-puso/altapresyon': 'HeartHealth/Hypertension',
  'kalusugan-puso/sakit-puso': 'HeartHealth/HeartDisease',
  'kalusugan-puso/iba-cardiovascular-issues':
    'HeartHealth/CardiovascularIssues',
  'kalusugan-puso/heart-arrhythmias': 'HeartHealth/HeartArrhythmias',
  'kalusugan-puso/cholesterol': 'HeartHealth/Cholesterol',
  'kalusugan-puso/heart-failure': 'HeartHealth/HeartFailure',
  'kalusugan-puso/atherosclerosis-fil': 'HeartHealth/Atherosclerosis',
  'kalusugan-puso/cardiomyopathy-fil': 'HeartHealth/Cardiomyopathy',
  'kalusugan-puso/congenital-heart-disease-fil':
    'HeartHealth/CongenitalHeartDisease',
  'kalusugan-puso/coronary-artery-disease': 'HeartHealth/Coronary',
  'kalusugan-puso/sakit-sa-heart-valve': 'HeartHealth/HeartValve',
  'kalusugan-puso/mga-impeksyon-sa-puso': 'HeartHealth/HeartInfections',
  'mga-herbal-at-alternatives': 'HerbalsAndAlternatives',
  'mga-herbal-at-alternatives/halamang-gamot':
    'HerbalsAndAlternatives/HerbalMedicines',
  'mga-herbal-at-alternatives/alternatibong-medisina':
    'HerbalsAndAlternatives/Alternatives',
  'nakahahawang-sakit': 'InfectiousDiseases',
  'nakahahawang-sakit/coronavirus-fil': 'InfectiousDiseases/Coronavirus',
  'nakahahawang-sakit/foodborne-infections-fil':
    'InfectiousDiseases/FoodborneInfections',
  'nakahahawang-sakit/meningitis-fil': 'InfectiousDiseases/Meningitis',
  'nakahahawang-sakit/viral-infections-fil':
    'InfectiousDiseases/ViralInfections',
  'nakahahawang-sakit/dengue-fil': 'InfectiousDiseases/Dengue',
  'nakahahawang-sakit/typhoid-fever-fil': 'InfectiousDiseases/TyphoidFever',
  'nakahahawang-sakit/iba-pang-bacterial-infection':
    'InfectiousDiseases/BacterialInfections',
  'nakahahawang-sakit/respiratory-infections-fil':
    'InfectiousDiseases/RespiratoryInfections',
  'oral-kalusugan': 'OralHealth',
  'oral-kalusugan/isyu-oral-kalusugan': 'OralHealth/OralIssues',
  'oral-kalusugan/sakit-sa-bibig-at-gilagid': 'OralHealth/GumDisease',
  'oral-kalusugan/oral-care-fil': 'OralHealth/OralCare',
  'oral-kalusugan/mga-dental-conditions': 'OralHealth/DentalConditions',
  'oral-kalusugan/cosmetic-dentistry-fil': 'OralHealth/CosmeticDentistry',
  'kalusugan-respiratory': 'RespiratoryHealth',
  'kalusugan-respiratory/influenza-fil': 'RespiratoryHealth/Influenza',
  'kalusugan-respiratory/hika': 'RespiratoryHealth/Asthma',
  'kalusugan-respiratory/bronchitis': 'RespiratoryHealth/Bronchitis',
  'kalusugan-respiratory/pneumonia-fil': 'RespiratoryHealth/Pneumonia',
  'kalusugan-respiratory/iba-isyu-respiratory':
    'RespiratoryHealth/RespiratoryIssues',
  'kalusugan-respiratory/sipon': 'RespiratoryHealth/CommonCold',
  'kalusugan-respiratory/emphysema-fil': 'RespiratoryHealth/Emphysema',
  'kalusugan-respiratory/tuberculosis-fil': 'RespiratoryHealth/Tuberculosis',
  'kalusugan-respiratory/bronchiectasis-fil':
    'RespiratoryHealth/Bronchiectasis',
  'kalusugan-respiratory/chronic-bronchitis-fil':
    'RespiratoryHealth/ChronicBronchitis',
  'sekswal-kaayusan': 'SexualWellness',
  'sekswal-kaayusan/mga-contraceptive': 'SexualWellness/Contraception',
  'sekswal-kaayusan/tips-sa-sex': 'SexualWellness/SexTips',
  'sekswal-kaayusan/trichomoniasis-fil': 'SexualWellness/Trichomoniasis',
  'sekswal-kaayusan/gonorrhea-fil': 'SexualWellness/Gonorrhea',
  'sekswal-kaayusan/stis-at-stds-sekswal-kaayusan': 'SexualWellness/StiStd',
  'sekswal-kaayusan/chlamydia-fil': 'SexualWellness/Chlamydia',
  'sekswal-kaayusan/ligtas-na-sex': 'SexualWellness/SafeSex',
  'sekswal-kaayusan/hiv-at-aids': 'SexualWellness/HivAids',
  'sekswal-kaayusan/hpv-fil': 'SexualWellness/Hpv',
  'sekswal-kaayusan/syphilis-fil': 'SexualWellness/Syphilis',
  'sekswal-kaayusan/genital-at-oral-herpes': 'SexualWellness/GenitalHerpes',
  'kalusugan-balat': 'SkinHealth',
  'kalusugan-balat/nakakahawang-sakit-balat': 'SkinHealth/SkinInfections',
  'kalusugan-balat/iba-pang-sakit-balat': 'SkinHealth/SkinIssues',
  'kalusugan-balat/pangangalaga-paglinis-balat': 'SkinHealth/SkincareCleansing',
  'kalusugan-balat/pangangalaga-buhok-anit': 'SkinHealth/HairScalpCare',
  'kalusugan-balat/pangangalaga-kuko': 'SkinHealth/NailCare',
  'kalusugan-balat/psoriasis-fil': 'SkinHealth/Psoriasis',
  'kalusugan-balat/dermatitis': 'SkinHealth/EczemaDermatitis',
  'kalusugan-balat/acne-fil': 'SkinHealth/Acne',
}

export const spotlightViVN: {
  [k: string]: string
} = {
  
}
